import { render, staticRenderFns } from "./TabWithdrawPending.vue?vue&type=template&id=f2b857fe&scoped=true&"
import script from "./TabWithdrawPending.vue?vue&type=script&lang=js&"
export * from "./TabWithdrawPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b857fe",
  null
  
)

export default component.exports